
import { FiChevronRight } from "react-icons/fi";
import { MdHub } from "react-icons/md";
import infraImg from "../../assets/infra.jpeg"

export function renderoverview () {
    return (
    <div className="transition-opacity duration-300">
    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-1">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">Overview</span>
    </nav>
      {/* Page Header */}
      <div className="mt-8">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-text-main dark:text-white mb-4">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Product Capabilities
        </span>
        </h1>
        <p className="text-xl text-text-secondary font-light leading-relaxed">
          How Netraa APM delivers Full-Stack Observability in practice, bridging the gap between application performance and infrastructure health.
        </p>
      </div>

      {/* Section 1: Technical Overview */}
      <section className="scroll-mt-24 mt-6 mb-1" id="technical-overview">
        <div className="flex items-center gap-3 mb-6">
          <div className="size-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <span className="material-symbols-outlined"><MdHub/></span>
          </div>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">
            Technical Overview
          </h2>
        </div>
        <p className="text-text-main dark:text-[#d0c8c0] leading-7 mb-8">
          Netraa consolidates system-level views into a single pane of glass. By correlating latency trends, infrastructure utilization (CPU/Memory), and database throughput, engineers can instantly pinpoint bottlenecks without context switching.
        </p>

        {/* Dashboard Mock */}
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-[#f3ede7] dark:border-[#3a2e24] shadow-sm p-1 overflow-hidden">
          {/* Fake Window Bar */}
          <div className="bg-[#fcfaf8] dark:bg-[#2a221a] px-4 py-2 border-b border-[#f3ede7] dark:border-[#3a2e24] flex items-center justify-between">
            <span className="text-xs font-medium text-text-secondary">System Health Dashboard</span>
            <div className="flex gap-1.5">
              <div className="size-2.5 rounded-full bg-red-400"></div>
              <div className="size-2.5 rounded-full bg-yellow-400"></div>
              <div className="size-2.5 rounded-full bg-green-400"></div>
            </div>
          </div>

          {/* Dashboard Cards */}
          <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6 bg-white dark:bg-[#221b15]">

            {/* Card 1: Avg Latency */}
            <div className="col-span-1 border border-[#f3ede7] dark:border-[#3a2e24] rounded-lg p-4">
              <div className="flex justify-between items-start mb-4">
                <h4 className="text-xs font-bold uppercase text-text-secondary">Avg Latency</h4>
                <span className="text-xs font-bold text-primary bg-primary/10 px-2 py-0.5 rounded">+12%</span>
              </div>
              <div className="text-2xl font-bold text-text-main dark:text-white mb-2">248ms</div>
              <div className="h-16 w-full flex items-end gap-1">
                <div className="w-1/6 h-[40%] bg-primary/20 rounded-t-sm"></div>
                <div className="w-1/6 h-[60%] bg-primary/30 rounded-t-sm"></div>
                <div className="w-1/6 h-[50%] bg-primary/20 rounded-t-sm"></div>
                <div className="w-1/6 h-[80%] bg-primary/60 rounded-t-sm"></div>
                <div className="w-1/6 h-[70%] bg-primary/40 rounded-t-sm"></div>
                <div className="w-1/6 h-[90%] bg-primary rounded-t-sm"></div>
              </div>
            </div>

            {/* Card 2: Infra Load */}
            <div className="col-span-1 border border-[#f3ede7] dark:border-[#3a2e24] rounded-lg p-4">
              <div className="flex justify-between items-start mb-4">
                <h4 className="text-xs font-bold uppercase text-text-secondary">Infra Load</h4>
                <span className="text-xs font-bold text-green-600 bg-green-100 dark:bg-green-900/30 px-2 py-0.5 rounded">Healthy</span>
              </div>
              <div className="flex gap-4">
                <div className="flex-1">
                  <div className="text-xs text-text-secondary mb-1">CPU</div>
                  <div className="w-full bg-[#f3ede7] dark:bg-[#3a2e24] rounded-full h-2">
                    <div className="bg-blue-500 h-2 rounded-full w-[45%]"></div>
                  </div>
                  <div className="text-right text-xs font-medium mt-1">45%</div>
                </div>
                <div className="flex-1">
                  <div className="text-xs text-text-secondary mb-1">Mem</div>
                  <div className="w-full bg-[#f3ede7] dark:bg-[#3a2e24] rounded-full h-2">
                    <div className="bg-purple-500 h-2 rounded-full w-[72%]"></div>
                  </div>
                  <div className="text-right text-xs font-medium mt-1">72%</div>
                </div>
              </div>
            </div>

            {/* Card 3: DB Activity */}
            <div className="col-span-1 border border-[#f3ede7] dark:border-[#3a2e24] rounded-lg p-4 relative overflow-hidden group">
              <div className="flex justify-between items-start mb-2">
                <h4 className="text-xs font-bold uppercase text-text-secondary">DB Activity</h4>
              </div>
              <div className="text-2xl font-bold text-text-main dark:text-white mb-1">
                14.2k <span className="text-sm font-normal text-text-secondary">ops/s</span>
              </div>
              <div className="absolute -bottom-4 -right-4 text-text-secondary opacity-10 group-hover:opacity-20 transition-opacity">
                <span className="material-symbols-outlined text-[100px]"><MdHub/></span>
              </div>
              <div className="h-10 mt-4 border-t border-dashed border-gray-200 dark:border-gray-700 relative">
                <svg className="w-full h-full absolute bottom-0" preserveAspectRatio="none">
                  <path d="M0 40 L10 35 L20 38 L30 20 L40 25 L50 10 L60 15 L70 5 L80 12 L90 8 L100 40 V40 H0 Z" fill="url(#grad1)" stroke="none"></path>
                  <path d="M0 40 L10 35 L20 38 L30 20 L40 25 L50 10 L60 15 L70 5 L80 12 L90 8 L100 40" fill="none" stroke="#ec7f13" strokeWidth="2"></path>
                  <defs>
                    <linearGradient id="grad1" x1="0%" x2="0%" y1="0%" y2="100%">
                      <stop offset="0%" style={{ stopColor: "#ec7f13", stopOpacity: 0.3 }} />
                      <stop offset="100%" style={{ stopColor: "#ec7f13", stopOpacity: 0 }} />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Section 2: Application Overview */}
      <section className="scroll-mt-24 mt-6 mb-1" id="application-overview">
        <div className="flex items-center gap-3 mb-6">
          <div className="size-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <span className="material-symbols-outlined"><MdHub/></span>
          </div>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">Application Overview</h2>
        </div>
        <p className="text-text-main dark:text-[#d0c8c0] leading-7 mb-8">
          Gain immediate insight into application-level performance indicators. This lucrative dashboard presents high-level KPIs including success rate, response latency, throughput, and Apdex score, paired with colorful error trend analysis.
        </p>

        {/* KPI Row */}
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-[#f3ede7] dark:border-[#3a2e24] shadow-lg overflow-hidden">
          <div className="p-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
              {/** KPI 1 */}
              <div className="p-4 rounded-xl bg-[#fcfaf8] dark:bg-[#221b15] border border-transparent hover:border-primary/30 transition-all">
                <div className="flex items-center gap-2 mb-2">
                  <span className="material-symbols-outlined text-green-500 text-sm">.</span>
                  <span className="text-xs font-semibold text-text-secondary uppercase">Success Rate</span>
                </div>
                <div className="text-3xl font-bold text-text-main dark:text-white">99.98%</div>
              </div>
              {/** KPI 2 */}
              <div className="p-4 rounded-xl bg-[#fcfaf8] dark:bg-[#221b15] border border-transparent hover:border-primary/30 transition-all">
                <div className="flex items-center gap-2 mb-2">
                  <span className="material-symbols-outlined text-primary text-sm">timelapse</span>
                  <span className="text-xs font-semibold text-text-secondary uppercase">Latency (p95)</span>
                </div>
                <div className="text-3xl font-bold text-text-main dark:text-white">
                  124<span className="text-base font-normal text-text-secondary ml-1">ms</span>
                </div>
              </div>
              {/** KPI 3 */}
              <div className="p-4 rounded-xl bg-[#fcfaf8] dark:bg-[#221b15] border border-transparent hover:border-primary/30 transition-all">
                <div className="flex items-center gap-2 mb-2">
                  <span className="material-symbols-outlined text-blue-500 text-sm">.</span>
                  <span className="text-xs font-semibold text-text-secondary uppercase">Throughput</span>
                </div>
                <div className="text-3xl font-bold text-text-main dark:text-white">
                  3.4k<span className="text-base font-normal text-text-secondary ml-1">rpm</span>
                </div>
              </div>
              {/** KPI 4 */}
              <div className="p-4 rounded-xl bg-[#fcfaf8] dark:bg-[#221b15] border border-transparent hover:border-primary/30 transition-all">
                <div className="flex items-center gap-2 mb-2">
                  <span className="material-symbols-outlined text-purple-500 text-sm">.</span>
                  <span className="text-xs font-semibold text-text-secondary uppercase">Apdex</span>
                </div>
                <div className="text-3xl font-bold text-text-main dark:text-white">0.96</div>
              </div>
            </div>

            {/* Error Trend Chart */}
            <div className="relative h-64 w-full bg-[#fcfaf8] dark:bg-[#221b15] rounded-xl p-4 border border-[#f3ede7] dark:border-[#3a2e24]">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm font-bold text-text-main dark:text-white">Error Rate Trend</h3>
                <div className="flex gap-2">
                  <span className="size-2 rounded-full bg-primary"></span>
                  <span className="text-xs text-text-secondary">5xx Errors</span>
                </div>
              </div>

              <div className="relative w-full h-48 flex items-end justify-between gap-1 px-2 overflow-hidden">
                {/* Background Grid */}
                <div className="absolute inset-0 flex flex-col justify-between pointer-events-none">
                  <div className="w-full h-px bg-gray-200 dark:bg-gray-700 border-dashed"></div>
                  <div className="w-full h-px bg-gray-200 dark:bg-gray-700 border-dashed"></div>
                  <div className="w-full h-px bg-gray-200 dark:bg-gray-700 border-dashed"></div>
                  <div className="w-full h-px bg-gray-200 dark:bg-gray-700 border-dashed"></div>
                </div>

                {/* Line Chart */}
                <svg className="absolute inset-0 w-full h-full chart-svg" preserveAspectRatio="none" viewBox="0 0 500 100">
                  <defs>
                    <linearGradient id="gradError" x1="0%" x2="0%" y1="0%" y2="100%">
                      <stop offset="0%" style={{ stopColor: "#ec7f13", stopOpacity: 0.5 }} />
                      <stop offset="100%" style={{ stopColor: "#ec7f13", stopOpacity: 0 }} />
                    </linearGradient>
                  </defs>
                  <path d="M0 90 Q 50 80 100 85 T 200 60 T 300 40 T 400 50 T 500 20 V 100 H 0 Z" fill="url(#gradError)"></path>
                  <path d="M0 90 Q 50 80 100 85 T 200 60 T 300 40 T 400 50 T 500 20" fill="none" stroke="#ec7f13" strokeLinecap="round" strokeWidth="3"></path>
                </svg>

                {/* Interactive Hover Point */}
                <div className="absolute top-[20%] left-[80%] flex flex-col items-center">
                  <div className="size-3 bg-white border-2 border-primary rounded-full shadow-md z-10"></div>
                  <div className="h-24 w-px bg-primary/50 border-dashed"></div>
                  <div className="absolute -top-10 bg-surface-dark text-white text-[10px] px-2 py-1 rounded shadow-lg whitespace-nowrap z-20">
                    12:45 PM • 2.1% Err
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Section 3: Infra Group Overview */}
      <section className="scroll-mt-24 mt-6 mb-16" id="infra-overview">
        <div className="flex items-center gap-3 mb-6">
          <div className="size-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <span className="material-symbols-outlined"><MdHub/></span>
          </div>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">Infra Group Overview</h2>
        </div>
        <p className="text-text-main dark:text-[#d0c8c0] leading-7 mb-8">
          Monitor your applications alongside their infrastructure with real-time network insights. Track metrics like network transmit and receive to understand service dependencies. Gain a clear view of resource usage and health for faster troubleshooting.        </p>

        {/* Infra Mapping Image */}
<div className="items-center justify-center">
  <img
    src={infraImg} 
    alt="Infrastructure Mapping"
    className="w-full h-auto object-contain rounded-lg shadow-md"
  />
</div>
      </section>
    </div>
  );
}